import React from 'react';
import {
  ListWrapper,
  ListBody,
  SectionTitle,
  SectionDivider,
  RowWrapper,
  RowTitle,
  RowDescription,
} from './MessageList.styled';

type ListRow = { id: string; title: string; description?: string };
type ListSection = { title?: string; rows: ListRow[] };
type MessageListProps = { body?: string; sections?: ListSection[] };

export function MessageList({ body, sections }: MessageListProps) {
  return (
    <ListWrapper>
      {body && <ListBody>{body}</ListBody>}
      {sections?.map((section, i) => (
        <React.Fragment key={i}>
          {i > 0 && <SectionDivider />}
          {section.title && <SectionTitle>{section.title}</SectionTitle>}
          {section.rows?.map((row) => (
            <RowWrapper key={row.id}>
              <RowTitle>{row.title}</RowTitle>
              {row.description && <RowDescription>{row.description}</RowDescription>}
            </RowWrapper>
          ))}
        </React.Fragment>
      ))}
    </ListWrapper>
  );
}
